import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import CrossIconRed from "../../../../assets/svg/icons/common/CrossIconRed";
import CheckMarkGreen from "../../../../assets/svg/icons/common/CheckMarkGreen";
import CaretRight24 from "../../../../assets/svg/icons/common/CaretRight24";

function BillingPreferences({ appData }) {
  const billing = appData?.billing;
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expanded, setExpanded] = useState(false);
  const isMobile = useMediaQuery(768);

  if (!billing) {
    return null;
  }

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const formatTime = (time) => {
    if (!time) {
      return "-";
    }
    return `EST ${time}`;
  };

  const formatAddressType = (value) => {
    if (!value) {
      return "-";
    }
    return value
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const renderYesNo = (value) => {
    if (value !== "" && value !== undefined && value !== null) {
      return value === "yes" ? (
        <>
          <CheckMarkGreen /> Yes
        </>
      ) : (
        <>
          <CrossIconRed /> No
        </>
      );
    }
    return "-";
  };

  const labelDeployEquipment =
    billing.who_to_deploy_equipment === "agent"
      ? "Agent"
      : billing.who_to_deploy_equipment === "processor"
        ? "Processor"
        : "-";

  const labelPayEquipment =
    billing.who_to_pay_for_equipment === "agent"
      ? "Agent"
      : billing.who_to_pay_for_equipment === "merchant"
        ? "Merchant"
        : "-";

  const labelDeployGateway =
    billing.who_to_deploy_gateway === "agent"
      ? "Agent"
      : billing.who_to_deploy_gateway === "processor"
        ? "Processor"
        : "-";

  const billingSequenceLabel =
    billing.billing_sequence === "daily" ? "Daily" : "Monthly";

  const items = [
    {
      label: "Opt merchant into expedited funding?",
      value: renderYesNo(billing.expedited_funding),
    },
    {
      label: "Preferred billing sequence",
      value: billing.billing_sequence ? billingSequenceLabel : "-",
    },
    {
      label: "Desired auto batch time",
      value: formatTime(billing.batch_time),
    },
    { label: "Who deploys equipment", value: labelDeployEquipment },
    { label: "Who pays for equipment", value: labelPayEquipment },
    { label: "Who deploys gateway", value: labelDeployGateway },
    {
      label: "Ship equipment to",
      value: formatAddressType(billing.equipment_address),
    },
    {
      label: "Send invoice to",
      value: formatAddressType(billing.invoice_address),
    },
    {
      label: "Special instructions",
      value: billing.special_instruction?.trim() ? billing.special_instruction : "-",
    },
  ];

  return (
    <div
      className={`${isMobile ? styles.mobile_business_info : styles.business_information} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div
        className={isMobile ? styles.business_info_header : styles.head}
        onClick={toggleExpanded}
      >
        {isMobile ? (
          <>
            <CaretRight24
              className={`${styles.caret_icon} ${expanded ? styles.expanded : ""}`}
            />
            <h4>Billing & funding</h4>
          </>
        ) : (
          <>
            <ButtonIcon>
              <CaretRight24 className={expanded ? styles.expanded : ""} />
            </ButtonIcon>
            <h5>Billing & funding</h5>
          </>
        )}
      </div>

      <div
        className={`${isMobile ? styles.mobile_content : styles.body} ${expanded ? (isMobile ? styles.expanded : styles.body_expanded) : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expanded && (
          <div className={styles.info_section}>
            <div className={styles.desktop_heading}>
              <HeadingWithLine text="Billing & funding" />
            </div>
            <div className={styles.info_grid}>
              {items.map((item, index) => (
                <div key={index} className={styles.info_item}>
                  <span className={styles.label}>{item.label}</span>
                  <span className={styles.value}>{item.value}</span>
                </div>
              ))}
            </div>
            <ul className={styles.desktop_list}>
              {items.map((item, index) => (
                <li key={index}>
                  <div>
                    <p>{item.label}</p>
                    <p>{item.value}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default BillingPreferences;
